import { render, staticRenderFns } from "./FailureModeTab.vue?vue&type=template&id=861ad72a"
import script from "./FailureModeTab.vue?vue&type=script&lang=ts"
export * from "./FailureModeTab.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports